// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__1aKUj","bookingInfo":"BookingTimeInfo_bookingInfo__1en-e","dateSection":"BookingTimeInfo_dateSection__1VA8Y"};